export class CssVarHelper {
    public static applyVars(nativeElement: HTMLElement, cssVars: Record<string, string | number | boolean | (string | number | boolean)[]>): void {
        Object.keys(cssVars).forEach((varName) => {
            const value: string | number | boolean | (string | number | boolean)[] = cssVars[varName];
            if (Array.isArray(value)) {
                const values: (string | number | boolean)[] = value.slice();
                let apply: boolean = true;
                if (values.length > 1 && typeof values[0] === "string") {
                    if (values[0].startsWith("?")) {
                        if (!CssVarHelper.hasVarSet(nativeElement, (<string>values.shift()).substring(1))) {
                            apply = false;
                        }
                    } else if (values[0].startsWith("!")) {
                        if (CssVarHelper.hasVarSet(nativeElement, (<string>values.shift()).substring(1))) {
                            apply = false;
                        }
                    }
                }
                if (apply) {
                    values.some((val) => CssVarHelper.applyValue(nativeElement, varName, val));
                } else {
                    nativeElement.style.removeProperty(varName);
                }
            } else {
                CssVarHelper.applyValue(nativeElement, varName, value);
            }
        });
    }

    public static applyValue(nativeElement: HTMLElement, varName: string, value: string | number | boolean): boolean {
        if (value === undefined) {
            nativeElement.style.removeProperty(varName);
            return true;
        }

        if (typeof value === "string" && value.startsWith("--")) {
            let otherValue: string = getComputedStyle(nativeElement).getPropertyValue(value);
            if (otherValue === undefined || otherValue === "") {
                otherValue = getComputedStyle(document.documentElement).getPropertyValue(value);
            }
            if (otherValue === undefined || otherValue === "") {
                nativeElement.style.removeProperty(varName);
                return false;
            }

            nativeElement.style.setProperty(varName, otherValue);
            return true;
        }

        nativeElement.style.setProperty(varName, `${value}`);
        return true;
    }

    public static removeVars(nativeElement: HTMLElement, cssVars: Record<string, string | number | boolean | (string | number | boolean)[]>): void {
        Object.keys(cssVars).forEach((varName) => {
            nativeElement.style.removeProperty(varName);
        });
    }

    public static hasVarSet(nativeElement: HTMLElement, checkVarName: string): boolean {
        const checkValue: string = getComputedStyle(nativeElement).getPropertyValue(checkVarName);
        return checkValue !== undefined && checkValue !== "";
    }
}
